// getters
const restaurantDeliveries = state => state.deliveries

export default {
  restaurantDeliveries
}



// WEBPACK FOOTER //
// ./src/store/modules/restaurant/deliveries/getters.js